import { render } from "./ComponentText.vue?vue&type=template&id=56949d69&scoped=true"
import script from "./ComponentText.vue?vue&type=script&lang=js"
export * from "./ComponentText.vue?vue&type=script&lang=js"

import "./ComponentText.vue?vue&type=style&index=0&id=56949d69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56949d69"]])

export default __exports__